import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { BorrowerIndexItem } from './borrower-index-item';

export interface BorrowerIndexQuery {
  sort: {}; // TODO tighten sort interface
  page: number;
  relationCriteria: {}; // TODO relationCriteria interface
  criteria: {}; // TODO tighten criteria interface
}

export interface BorrowerIndexPaginatedResponse {
  current_page: number;
  data: BorrowerIndexItem[];
  total: number;
  next_page_url: string;
}

export interface BorrowerResultCounts {
  all: number;
}

@Injectable({
  providedIn: 'root'
})
export class BorrowerIndexService {

  constructor(
    private http: ApiHttpClient
  ) { }

  get({ sort, page, criteria, relationCriteria }: BorrowerIndexQuery): Observable<BorrowerIndexPaginatedResponse> {
    return this.http.get<BorrowerIndexPaginatedResponse>(`${environment.API_URL}/borrower`, {
      params: {
        context: 'ls',
        page,
        query: JSON.stringify({
          sort,
          criteria,
          relationCriteria
        })
      }
    });
  }
}
